export const ASSET_SRC = {
    logo: process.env.REACT_APP_ASSET_LOGO,
    laptop_phone: process.env.REACT_APP_ASSET_LAPTOP_PHONE,
    email_denied: process.env.REACT_APP_ASSET_EMAIL_DENIED,
    email_pending: process.env.REACT_APP_ASSET_EMAIL_PENDING,
    email_success: process.env.REACT_APP_ASSET_EMAIL_SUCCESS,
    short_logo: process.env.REACT_APP_ASSET_SHORT_LOGO,
    search_barcode_image: process.env.REACT_APP_ASSET_SEARCH_BARCODE_IMAGE,
    search_barcode_number: process.env.REACT_APP_ASSET_SEARCH_BARCODE_NUMBER,
    search_food_name: process.env.REACT_APP_ASSET_SEARCH_FOOD_NAME,
};
